module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/notokr-light.woff
// module id = o3vO
// module chunks = 0